module.exports = __webpack_public_path__ + "img/dustland_slide_1.8a84e2ab.jpg";